
export function addedToCart(goodId, goodName, quantity, price) {
    new Promise((resolve, reject) => {
        resolve();
    })
        .then(() => {
            useFrame(`/ecommerce/added-to-cart/?id=${goodId}&name=${goodName}&quantity=${quantity}&price=${price}`);
        })
}

function useFrame(src) {
    const id = Math.random().toString(36).substring(7);
    const iframe = document.createElement("iframe");
    iframe.id = id;
    iframe.src = src;
    iframe.width = '0';
    iframe.height = '0';
    document.body.appendChild(iframe);

    const frameForParentPage = document.getElementById(id);
    frameForParentPage.onload = function() {
        $(frameForParentPage).remove();
    };
}
